var map = {
	"./add-frame.svg": "fc87",
	"./add-option.svg": "c4bd",
	"./add-point.svg": "ea8d",
	"./checkbox.svg": "0704",
	"./click-type.svg": "07b2",
	"./close.svg": "312c",
	"./copy.svg": "f777",
	"./delete-1.svg": "e388",
	"./delete-2.svg": "3fc2",
	"./delete.svg": "a853",
	"./edit.svg": "2f0e",
	"./error.svg": "7503",
	"./loading.svg": "9c6e",
	"./location.svg": "9224",
	"./match.svg": "bed5",
	"./multiple-choice.svg": "fd47",
	"./ok.svg": "b7e7",
	"./point.svg": "725d",
	"./radio.svg": "9870",
	"./single-choice.svg": "1312",
	"./star.svg": "230d",
	"./table-expand.svg": "714f",
	"./textbox.svg": "8a85",
	"./tips.svg": "5f15"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "da18";